import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { StatusCardImageSection } from '../status-card-image-section/StatusCardImageSection';
import { StatusCardSvgSection } from '../status-card-svg-section/StatusCardSvgSection';
import { getFailurePageStyles } from './FailurePageStyles';
import { OfferStripWidget } from '../../../offer-strip-widget';
export var FailurePage = props => {
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var failurePageStyles = getFailurePageStyles(isLargeScreen);
  var _props$statusCardProp = props.statusCardProps,
    imageProps = _props$statusCardProp.imageProps,
    title = _props$statusCardProp.title,
    subtitle = _props$statusCardProp.subtitle,
    description = _props$statusCardProp.description,
    _props$statusCardProp2 = _props$statusCardProp.offerStripProps,
    offerStripProps = _props$statusCardProp2 === void 0 ? {} : _props$statusCardProp2,
    _props$infoSectionPro = props.infoSectionProps,
    infoNavigationArray = _props$infoSectionPro.infoNavigationArray,
    buttonProps = _props$infoSectionPro.buttonProps,
    onUserAction = props.onUserAction,
    id = props.id,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    _props$svg = props.svg,
    svg = _props$svg === void 0 ? {} : _props$svg,
    _props$type = props.type,
    type = _props$type === void 0 ? 'svg' : _props$type;
  return _jsxs(View, Object.assign({
    style: failurePageStyles.container
  }, {
    children: [_jsxs(View, Object.assign({
      style: failurePageStyles.statusCard
    }, {
      children: [_jsxs(View, Object.assign({
        style: failurePageStyles.marginBottom
      }, {
        children: [type === 'image' && _jsx(StatusCardImageSection, Object.assign({}, imageProps)), type === 'svg' && _jsx(StatusCardSvgSection, Object.assign({}, svg))]
      })), _jsxs(View, Object.assign({
        style: failurePageStyles.statusCardTitle
      }, {
        children: [!!title && _jsx(Typography, Object.assign({
          text: title,
          type: isLargeScreen ? 'body-single-line-xl-bold' : 'body-single-line-lg-bold',
          theme: theme,
          style: failurePageStyles.title
        }, getTestId('title', 'acknowledgementfailurepage'))), !!subtitle && _jsx(Typography, Object.assign({
          multiText: subtitle,
          type: 'body-para-sm',
          theme: theme
        }, getTestId('subtitle', 'acknowledgementfailurepage'))), !!description && _jsx(Typography, Object.assign({
          text: description,
          type: isLargeScreen ? 'body-para-md' : 'body-para-sm',
          theme: theme,
          style: failurePageStyles.description
        }, getTestId('description', 'acknowledgementfailurepage'))), isValidObject(offerStripProps) && _jsx(OfferStripWidget, Object.assign({}, getTestId('offerstrip', 'acknowledgementfailurepage'), offerStripProps, {
          style: failurePageStyles.offerStrip
        }))]
      }))]
    })), _jsxs(View, Object.assign({
      style: failurePageStyles.detailsSection
    }, {
      children: [!!buttonProps && _jsx(View, Object.assign({
        style: failurePageStyles.buttonSection
      }, getTestId('buttonprops', 'acknowledgementfailurepage'), {
        children: buttonProps.map(button => {
          return _jsx(Button, {
            size: isLargeScreen ? 'md' : 'sm',
            title: button === null || button === void 0 ? void 0 : button.title,
            buttonType: button === null || button === void 0 ? void 0 : button.type,
            style: failurePageStyles.actionCta,
            onPress: () => {
              (button === null || button === void 0 ? void 0 : button.actionCtaPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, button === null || button === void 0 ? void 0 : button.actionCtaPressMetaData), {
                button
              }));
            }
          });
        })
      })), !!infoNavigationArray && _jsx(View, Object.assign({
        style: failurePageStyles.navigateSection
      }, getTestId('infoNavigationArray', 'acknowledgementfailurepage'), {
        children: infoNavigationArray === null || infoNavigationArray === void 0 ? void 0 : infoNavigationArray.map(info => _jsx(View, Object.assign({
          style: failurePageStyles.navigateSectionCta
        }, {
          children: _jsx(Typography, {
            multiText: info === null || info === void 0 ? void 0 : info.multiText,
            type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
            theme: theme
          })
        })))
      }))]
    }))]
  }));
};